import { IconButton } from '@mui/material';

import { mui } from '../libs';

type PanelWithHeaderProps = {
  title: string;
  children: React.ReactNode;

  rightAction?: React.ReactNode;
  icon?: React.ReactNode;
};

/**
 * Component that displays a panel with a header and a content area.
 *
 * @param title - The title to be displayed in the header
 * @param children - The content to be displayed in the panel
 * @param icon - The icon to be displayed in the header
 * @param rightAction - The action to be displayed in the right side of the header
 *
 * @returns Rendered component with a panel having a header and a content area
 */

const PanelWithHeader = ({ children, title, icon = null, rightAction = null }: PanelWithHeaderProps) => {
  const theme = mui.styles.useTheme() as mui.core.Theme;

  return (
    <>
      <mui.core.Box
        p={2}
        display="flex"
        alignItems="center"
        sx={{
          borderBottom: `1px solid ${theme.palette.divider}`,
        }}
        gap={3}
      >
        {icon && (
          <IconButton sx={{ background: theme.palette.primaryLight.light, pointerEvents: 'none' }}>{icon}</IconButton>
        )}
        <mui.core.Typography variant="h6" sx={{ flex: 1 }}>
          {title}
        </mui.core.Typography>
        {rightAction && rightAction}
      </mui.core.Box>
      <mui.core.Box
        sx={{
          overflow: 'auto',
          height: 'calc(100% - 40px)',
        }}
      >
        {children}
      </mui.core.Box>
    </>
  );
};

export default PanelWithHeader;
